import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { HttpService } from "src/app/share-modul/services/common/http-service";
import { WaiterHttpService } from "src/app/share-modul/services/common/waiter-http-service";
import { environment } from "src/environments/environment";

const WTR_CAPACITY_API = environment.apiURL + '/api/wtr/Capacity/';

@Injectable({
  providedIn: 'root'
})

export class CapacityService {

  //#region Fields
  //#endregion

  //#region Constructor
  constructor( private _waiterHttpService: WaiterHttpService, private _httpClient: HttpClient) {
  }

  //#endregion

  //#region Public Methods
  viewdefaultcapacitytemplate(venueId: string) {
    var url = WTR_CAPACITY_API + "viewdefaultcapacitytemplate?venueId=" + venueId;
    return this._waiterHttpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }
  viewTableDetails(tableId: string) {
    var url = WTR_CAPACITY_API + "gettabledetailsbyId?TableId=" + tableId;
    return this._waiterHttpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }
  //#endregion
}
